import React, { useContext } from "react";
import CustomCard from "../../styleComp/CustomCard";
import { IconButton, Grid, Button, Typography } from "@mui/material";
import Box from "@mui/material/Box";
import PaymentIcon from "@mui/icons-material/Payment";
import DescriptionIcon from "@mui/icons-material/Description";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import PersonIcon from "@mui/icons-material/Person";
import InfoIcon from "@mui/icons-material/Info";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import imageUrl from "../../images/111.png";
import { useNavigate } from "react-router-dom";
import { RolesContext } from "../../context/User";

const NavigationMenuCard = () => {
  const navigate = useNavigate();
  const [stateroles, dispatchroles] = useContext(RolesContext);

  const gradientStyleMD = {
    width: "15vw",
    height: "35vh",
    borderRadius: "20px",
    marginTop: "2rem",
  };

  const gradientStyleXL = {
    width: "20vw",
    height: "40vh",
    borderRadius: "20px",
    marginTop: "2rem",
  };

  const ButtonStyleMD = {
    paddingTop: "1rem",
    paddingBottom: "1rem",
    width: "14.5vw",
    borderRadius: "20px",
  };

  const ButtonStyleXL = {
    paddingTop: "1.5rem",
    paddingBottom: "1.5rem",
    width: "11vw",
    borderRadius: "20px",
  };

  const TypographyStyle = {
    marginRight: "0.6px",
    fontWeight: "bold",
  };

  const navigationNavMenu = (selectedValue) => {
    navigate(`/${selectedValue}`);
  };

  return (
    <>
      {/* -----------------------display md--------------------------------------- */}
      <Box sx={{ display: { xs: "none", md: "flex", xl: "none" } }}>
        <CustomCard
          widthCard={"100vw"}
          heightCard={"43vh"}
          backgroundColorStyle={"rgb(41,91,154)"}
        >
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
          >
            <Grid container spacing={2} justifyContent="center">
              {(stateroles.roles.includes("linkopeninvoice") ||
                stateroles.roles.includes("admin")) &&
              stateroles.priorityCode === "A" ? (
                <Grid item xs={6}>
                  <Button
                    color="inherit"
                    style={ButtonStyleMD}
                    variant="contained"
                    onClick={() => navigationNavMenu("linkopeninvoice")}
                  >
                    <PaymentIcon />
                    <Typography style={TypographyStyle}>
                      חשבוניות לתשלום
                    </Typography>
                  </Button>
                </Grid>
              ) : null}
              {stateroles.roles.includes("getinvoice") ||
              stateroles.roles.includes("admin") ? (
                <Grid item xs={6}>
                  <Button
                    color="inherit"
                    style={ButtonStyleMD}
                    variant="contained"
                    onClick={() => navigationNavMenu("getinvoice")}
                  >
                    <DescriptionIcon />
                    <Typography style={TypographyStyle}>
                      חשבוניות וקבלות
                    </Typography>
                  </Button>
                </Grid>
              ) : null}
              {stateroles.roles.includes("openorder") ||
              stateroles.roles.includes("admin") ? (
                <Grid item xs={6}>
                  <Button
                    color="inherit"
                    style={ButtonStyleMD}
                    variant="contained"
                    onClick={() => navigationNavMenu("openorder")}
                  >
                    <LocalShippingIcon />
                    <Typography style={TypographyStyle}> הזמנות</Typography>
                  </Button>
                </Grid>
              ) : null}
              {stateroles.roles.includes("shipping") ||
              stateroles.roles.includes("admin") ? (
                <Grid item xs={6}>
                  <Button
                    color="inherit"
                    style={ButtonStyleMD}
                    variant="contained"
                    onClick={() => navigationNavMenu("shipping")}
                  >
                    <ReceiptLongIcon />
                    <Typography style={TypographyStyle}>
                      {" "}
                      תעודות משלוח
                    </Typography>
                  </Button>
                </Grid>
              ) : null}
              {stateroles.roles.includes("roles") ||
              stateroles.roles.includes("admin") ? (
                <Grid item xs={6}>
                  <Button
                    color="inherit"
                    style={ButtonStyleMD}
                    variant="contained"
                    onClick={() => navigationNavMenu("roles")}
                  >
                    <PersonIcon />
                    <Typography style={TypographyStyle}> הרשאות</Typography>
                  </Button>
                </Grid>
              ) : null}
              <Grid item xs={6}>
                <Button
                  color="inherit"
                  style={ButtonStyleMD}
                  variant="contained"
                  onClick={() => navigationNavMenu("about")}
                >
                  <InfoIcon />
                  <Typography style={TypographyStyle}> מידע נוסף</Typography>
                </Button>
              </Grid>
            </Grid>
            <img src={imageUrl} alt="Sample" style={gradientStyleMD} />
          </Box>
        </CustomCard>
      </Box>

      {/* -----------------------display XL--------------------------------------- */}

      <Box sx={{ display: { xs: "none", md: "none", xl: "flex" } }}>
        <CustomCard
          widthCard={"100vw"}
          heightCard={"43vh"}
          backgroundColorStyle={"rgb(41,91,154)"}
        >
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
          >
            <Grid
              container
              spacing={2}
              justifyContent="center"
              sx={{ marginLeft: "1rem" }}
            >
              {(stateroles.roles.includes("linkopeninvoice") ||
                stateroles.roles.includes("admin")) &&
              stateroles.priorityCode === "A" ? (
                <Grid item xs={6}>
                  <Button
                    color="inherit"
                    style={ButtonStyleXL}
                    variant="contained"
                    onClick={() => navigationNavMenu("linkopeninvoice")}
                  >
                    <PaymentIcon />
                    <Typography style={TypographyStyle}>
                      חשבוניות לתשלום
                    </Typography>
                  </Button>
                </Grid>
              ) : null}
              {stateroles.roles.includes("getinvoice") ||
              stateroles.roles.includes("admin") ? (
                <Grid item xs={6}>
                  <Button
                    color="inherit"
                    style={ButtonStyleXL}
                    variant="contained"
                    onClick={() => navigationNavMenu("getinvoice")}
                  >
                    <DescriptionIcon />
                    <Typography style={TypographyStyle}>
                      חשבוניות וקבלות
                    </Typography>
                  </Button>
                </Grid>
              ) : null}
              {stateroles.roles.includes("openorder") ||
              stateroles.roles.includes("admin") ? (
                <Grid item xs={6}>
                  <Button
                    color="inherit"
                    style={ButtonStyleXL}
                    variant="contained"
                    onClick={() => navigationNavMenu("openorder")}
                  >
                    <LocalShippingIcon />
                    <Typography style={TypographyStyle}> הזמנות</Typography>
                  </Button>
                </Grid>
              ) : null}
              {stateroles.roles.includes("shipping") ||
              stateroles.roles.includes("admin") ? (
                <Grid item xs={6}>
                  <Button
                    color="inherit"
                    style={ButtonStyleXL}
                    variant="contained"
                    onClick={() => navigationNavMenu("shipping")}
                  >
                    <ReceiptLongIcon />
                    <Typography style={TypographyStyle}>
                      {" "}
                      תעודות משלוח
                    </Typography>
                  </Button>
                </Grid>
              ) : null}
              {stateroles.roles.includes("roles") ||
              stateroles.roles.includes("admin") ? (
                <Grid item xs={6}>
                  <Button
                    color="inherit"
                    style={ButtonStyleXL}
                    variant="contained"
                    onClick={() => navigationNavMenu("roles")}
                  >
                    <PersonIcon />
                    <Typography style={TypographyStyle}> הרשאות</Typography>
                  </Button>
                </Grid>
              ) : null}
              <Grid item xs={6}>
                <Button
                  color="inherit"
                  style={ButtonStyleXL}
                  variant="contained"
                  onClick={() => navigationNavMenu("about")}
                >
                  <InfoIcon />
                  <Typography style={TypographyStyle}> מידע נוסף</Typography>
                </Button>
              </Grid>
            </Grid>
            <img src={imageUrl} alt="Sample" style={gradientStyleXL} />
          </Box>
        </CustomCard>
      </Box>
    </>
  );
};

export default NavigationMenuCard;